import { isDevMode } from "@/constants";
import { gtm } from "@/lib/gtm";
import posthog from "posthog-js";

interface BaseEvent {
  event: string;
  eventCategory: string;
  eventLabel: string;
  eventAction: string;
  userId?: string | undefined;
}

type CtaEvent = BaseEvent & {
  eventCategory: "cta";
};

type PortfolioEvent = BaseEvent & {
  eventCategory: "portfolio";
  portfolioId: string;
};

type AssetEvent = BaseEvent & {
  eventCategory: "asset";
  portfolioId?: string;
  assetName: string;
};

type SocialEvent = BaseEvent & {
  eventCategory: "social";
  postId?: string;
  repostId?: string;
  commentId?: string;
  followerId?: string;
  followingId?: string;
};

type LinkEvent = BaseEvent & {
  eventCategory: "link";
};

type TournamentEvent = BaseEvent & {
  eventCategory: "tournament";
  tournamentId: string;
};

export type GtmCustomEvent =
  | CtaEvent
  | PortfolioEvent
  | AssetEvent
  | SocialEvent
  | LinkEvent
  | BaseEvent
  | TournamentEvent;

function push(payload: GtmCustomEvent) {
  if (isDevMode) {
    return;
  }
  gtm.pushToDataLayer(payload);
  posthog.capture(payload.event, payload);
}

export const GtmService = Object.freeze({
  push,
});
